export function simpleFormat(text: string) {
  let paragraphs = text.trim().split(/\r?\n(?:\r?\n)+/g)

  paragraphs = paragraphs.map((paragraph) => {
    return paragraph
      .replaceAll(/\r?\n/g, '<br>')
      .replaceAll(/(\b\S+@\S+\.\w+)/g, '<a href="mailto:$1">$1</a>')
  })

  return `<p>${paragraphs.join('</p><p>')}</p>`
}
